// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextField border styling with proper state transitions */
.browser-access-login-card .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: rgba(0,0,0,0.2);
  border-width: 1px;
  border-style: solid;
  transition: border-color 0.2s ease;
}

.browser-access-login-card .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
.browser-access-login-card .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
.browser-access-login-card .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: rgba(0,0,0,0.6);
  border-width: 1px;
}

/* Prevent any text field input from having a border itself */
.browser-access-login-card .MuiOutlinedInput-input {
  border: none;
}

/* Text input styling */
.browser-access-login-card .MuiOutlinedInput-input {
  height: 1.4375em;
  padding: 16.5px 14px;
}

/* Remove blue background from autofill */
.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill,
.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill:hover,
.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill:focus,
.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* Firefox specific autofill handling */
.browser-access-login-card .MuiOutlinedInput-input:-moz-autofill,
.browser-access-login-card .MuiOutlinedInput-input:-moz-autofill:focus {
  background-color: white;
  box-shadow: 0 0 0 30px white inset;
}

/* For Microsoft Edge/IE */
.browser-access-login-card .MuiOutlinedInput-input:-ms-input-placeholder {
  background-color: white;
} `, "",{"version":3,"sources":["webpack://./src/pages/ZycusChat/components/BrowserAccess/styles.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;;EAGE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;;;;EAIE,0CAA0C;EAC1C,4CAA4C;EAC5C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,uCAAuC;AACvC;;EAEE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;AACzB","sourcesContent":["/* TextField border styling with proper state transitions */\n.browser-access-login-card .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(0,0,0,0.2);\n  border-width: 1px;\n  border-style: solid;\n  transition: border-color 0.2s ease;\n}\n\n.browser-access-login-card .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,\n.browser-access-login-card .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,\n.browser-access-login-card .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(0,0,0,0.6);\n  border-width: 1px;\n}\n\n/* Prevent any text field input from having a border itself */\n.browser-access-login-card .MuiOutlinedInput-input {\n  border: none;\n}\n\n/* Text input styling */\n.browser-access-login-card .MuiOutlinedInput-input {\n  height: 1.4375em;\n  padding: 16.5px 14px;\n}\n\n/* Remove blue background from autofill */\n.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill,\n.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill:hover,\n.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill:focus,\n.browser-access-login-card .MuiOutlinedInput-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset;\n  -webkit-text-fill-color: rgba(0, 0, 0, 0.87);\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Firefox specific autofill handling */\n.browser-access-login-card .MuiOutlinedInput-input:-moz-autofill,\n.browser-access-login-card .MuiOutlinedInput-input:-moz-autofill:focus {\n  background-color: white;\n  box-shadow: 0 0 0 30px white inset;\n}\n\n/* For Microsoft Edge/IE */\n.browser-access-login-card .MuiOutlinedInput-input:-ms-input-placeholder {\n  background-color: white;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
